import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ViewProfileService {
  private apiUrl = environment.BASE_URL;
  
  constructor(
    private readonly http: HttpClient,
    private readonly apiUrlService: ApiUrlService
  ) {}

  getProfile(): Observable<any> {
    return this.http.get<{ data: any }>(
      this.apiUrl+'users/profile'
    );
  }
  getProfileById(id: any): Observable<any> {
    return this.http.get<{ data: any }>(
      this.apiUrl+`users/profile/${id}`
    );
  }


  updateProfile(payload: any) {
    return this.http.put<any>(
      `${this.apiUrl}users/profile`,
      payload
    );
  }

  updateProfileWithLogo(formData: FormData): Observable<any> {
    // Note: Do not set Content-Type header manually for FormData
    // Angular will automatically set it with the correct boundary
    return this.http.put<any>(
      `${this.apiUrl}users/profile`,
      formData
    );
  }
}